module.exports = __webpack_public_path__ + "img/chart.cc943033.svg";